module.exports = __webpack_public_path__ + "static/media/bone3.0576578e.png";